import {
  Currency,
  CardScheme,
  StoredCardStatus,
  CardTokenType,
  PaymentMethod,
} from "@/types";

const CURRENCY = new Map<Currency, string>([
  [Currency.SAR, "SAR"],
  [Currency.AED, "AED"],
  [Currency.KWD, "KWD"],
  [Currency.QAR, "QAR"],
  [Currency.BHD, "BHD"],
  [Currency.OMR, "OMR"],
]);

const CARD_SCHEME = new Map<CardScheme, string>([
  [CardScheme.MASTERCARD, "mastercard"],
  [CardScheme.VISA, "visa"],
  [CardScheme.AMEX, "amex"],
  [CardScheme.MADA, "mada"],
  [CardScheme.KNET, "knet"],
]);

const STORED_CARD_STATUS = new Map<StoredCardStatus, string>([
  [StoredCardStatus.UNKNOWN, "unknown"],
  [StoredCardStatus.ACTIVE, "active"],
]);

const CARD_TOKEN_TYPE = new Map<CardTokenType, string>([
  [CardTokenType.CARD, "card"],
  [CardTokenType.PREPAID, "prepaid"],
]);

const PAYMENT_METHOD = new Map<PaymentMethod, string>([
  [PaymentMethod.KNET_CARD, "KnetCreditCard"],
  [PaymentMethod.APPLE_PAY, "CheckoutApplePay"],
  [PaymentMethod.CREDIT_CARD, "CheckoutCreditCard"],
  [PaymentMethod.MADA_CARD, "CheckoutMadaCard"],
  [PaymentMethod.TAMARA_PAY_CARD, "TamaraPayCard"],
  [PaymentMethod.BANK_TRANSFER, "BankTransfer"],
]);

const getByKey =
  <K, V>(map: Map<K, V>) =>
  (key: K) =>
    map.get(key) ?? null;

const getByValue =
  <K, V>(map: Map<K, V>) =>
  (value: V) =>
    Array.from(map.keys())[Array.from(map.values()).indexOf(value)] ?? null;

export const encodeCurrency = getByKey(CURRENCY);
export const decodeCurrency = getByValue(CURRENCY);
export const encodeCardScheme = getByKey(CARD_SCHEME);
export const decodeCardScheme = getByValue(CARD_SCHEME);
export const encodeStoredCardStatus = getByKey(STORED_CARD_STATUS);
export const decodeStoredCardStatus = getByValue(STORED_CARD_STATUS);
export const decodeCardTokenType = getByValue(CARD_TOKEN_TYPE);
export const decodePaymentMethod = getByValue(PAYMENT_METHOD);
export const encodePaymentMethod = getByKey(PAYMENT_METHOD);
